import React from "react";

export default function Pill({ children, ...props }) {
  return (
    <div
      className="!rounded-lg border-primary-600 border-2 text-primary-200 px-4 py-1 uppercase max-w-fit text-xs md:text-sm font-medium"
      {...props}
    >
      {children}
    </div>
  );
}
